import React from 'react';

const Game = () => {
  return <div></div>;
};

export default Game;
